<template>
  <div>
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-bind:class="result">
      <div class="row">
        <div class="col-12">
          <noticiasview
            v-if="
              usuario_permisos.nomseccion3.indexOf('Ver Slider Noticias') >=
                0 && cia.noticias
            "
          ></noticiasview>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-10">
          <div class="card bg-light no-card-border">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="m-r-10 mr-3">
                  <img
                    v-bind:src="menu.usuario.foto_empleado"
                    alt="user"
                    width="60"
                    class="rounded-circle"
                  />
                </div>
                <div>
                  <h3 class="m-b-0" id="nombreEmpleado">
                    {{ $t("page.content_dashboard.saludo.title") }}
                    {{ menu.usuario.nombre_empleado }}
                  </h3>
                  <span>{{ fecha_actual }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 mt-3">
          <climaview></climaview>
        </div>
      </div>

      <administradorview
        class="card-group"
        v-if="
          usuario.usuario_sistema == 'Administrador' ||
          usuario.usuario_sistema == 'HISE' ||
          usuario.usuario_sistema == 'Rep. Empresa'
        "
      >
      </administradorview>
      <participanteview
        v-if="
          usuario.usuario_sistema == 'Contratista' ||
          usuario.usuario_sistema == 'Instructor'
        "
        class="card-group"
      >
      </participanteview>

      <div class="row">
        <!-- Column -->
        <div class="col-md-6 px-0">
          <modalidadxmes
            v-if="
              usuario.usuario_sistema == 'Administrador' ||
              usuario.usuario_sistema == 'HISE' ||
              usuario.usuario_sistema == 'Rep. Empresa'
            "
          />
          <nuevasTabs v-else-if="usuario.usuario_sistema == 'Contratista'" />
          <miscursosinstructor
            v-else-if="usuario.usuario_sistema == 'Instructor'"
          />
        </div>
        <div class="col-md-6 px-0">
          <capacitacionxregion
            v-if="
              usuario.usuario_sistema == 'Administrador' ||
              usuario.usuario_sistema == 'HISE' ||
              usuario.usuario_sistema == 'Rep. Empresa'
            "
          >
          </capacitacionxregion>
          <encuestas
            v-if="
              usuario.usuario_sistema == 'Contratista' ||
              usuario.usuario_sistema == 'Instructor'
            "
          ></encuestas>
        </div>
        <!-- <div class="col-md-3 px-0">
          <tareas></tareas>
        </div> -->
      </div>

      <div class="row">
        <div class="col-sm-12">
          <rankingview
            v-if="
              usuario.usuario_sistema == 'Administrador' ||
              usuario.usuario_sistema == 'HISE' ||
              usuario.usuario_sistema == 'Rep. Empresa'
            "
          ></rankingview>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <ProveedorView
            v-if="Number(usuario.perfil_sistema) == 4"
          ></ProveedorView>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalChangePass"
      role="dialog"
      aria-labelledby="Cambiar contraseña"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Cambiar contraseña
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form
            class="form"
            autocomplete="off"
            v-on:submit.prevent="cambiarContrasena()"
          >
            <div class="modal-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label for="contAct">Contraseña actual</label>
                      <input
                        autocomplete="off"
                        required="required"
                        type="password"
                        class="form-control"
                        id="contAct"
                        v-model="contAct"
                      />
                    </div>
                    <div class="form-group">
                      <label for="nuevaCont">Nueva contraseña</label>
                      <input
                        autocomplete="false"
                        required="required"
                        type="password"
                        :class="'form-control ' + classPass"
                        id="nuevaCont"
                        v-model="nuevaCont"
                      />
                    </div>
                    <div class="form-group">
                      <label for="repCont">Repite la contraseña</label>
                      <input
                        autocomplete="false"
                        required="required"
                        type="password"
                        :class="'form-control ' + classPass1"
                        id="repCont"
                        v-model="repCont"
                      />
                    </div>
                  </div>
                  <div class="col-6 align-self-center">
                    <div
                      v-for="(regla, index) in reglas"
                      :key="'regla' + index"
                    >
                      <p class="white">
                        <i
                          :class="regla.class + ' fas fa-check-circle'"
                          v-if="regla.class == 'text-success'"
                        ></i>
                        <i
                          v-else
                          :class="regla.class + ' fas fa-exclamation-circle'"
                        ></i>
                        {{ regla.text }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="!permitirEnvio"
              >
                Cambiar contraseña
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalSlides"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalSlidesLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title" id="modalSlidesLabel">
              {{
                `${
                  moduloSlidesActual == "bienvenida"
                    ? "Bienvenid@ a la web de capacitacion para contratistas"
                    : moduloSlidesActual == "noticia"
                    ? "Noticias y avisos"
                    : "Configuracion"
                }`
              }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div> -->
          <div class="modal-body">
            <SlidesBienvenida
              :slides="slides"
              @setModuloActual="setModuloActual($event)"
            />
            <div class="form-check text-end">
              <input
                type="checkbox"
                class="form-check-input"
                id="labelMostrarSlides"
                v-model="statusSlidesBienvenida"
              />
              <label class="form-check-label" for="labelMostrarSlides"
                >No volver a mostrar.</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProveedorView from "./Vistas_Por_Perfil/Proveedor.vue"
import AdministradorView from "./Vistas_Por_Perfil/Administrador.vue";
import ParticipanteView from "./Vistas_Por_Perfil/Participante.vue";
import NoticiasView from "./Noticias/Noticias.vue";
import ClimaView from "./Clima/Clima.vue";
import Tareas_View from "./Tareas/Tareas.vue";
import Ranking_View from "./Ranking/Ranking.vue";
import ModalidadxMes from "./ModalidadxMes/ModalidadxMes.vue";
import CapacitacionxRegion from "./CapacitacionxRegion/CapacitacionxRegion.vue";
import MisConstancias from "./MisConstancias/MisConstancias.vue";
import nuevasTabs from "./Vistas_Por_Perfil/Tabs/tabsDashboard.vue";
import MisCursosInstructor from "./MisCursosInstructor/MisCursosInstructor.vue";
import Encuestas from "./Encuestas/Encuestas.vue";
import SlidesBienvenida from "./SlidesBienvenida.vue";
import Vue from "vue";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      slides: [],
      statusSlidesBienvenida: false,
      moduloSlidesActual: "Bienvenida",
      loading: "",
      result: "d-none",
      fecha_actual: "",
      repCont: "",
      contAct: "",
      nuevaCont: "",
      classPass: "is-invalid",
      classPass1: "is-invalid",
      reglas: [
        {
          text: "Longitud de contraseña: minimo 8 caracteres",
          isValid: (value) => {
            if (value.length >= 8) {
              return true;
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Caracteres numericos: minimo 2 numeros",
          isValid: (value) => {
            let bandera = 0;
            for (let i = 0; i < value.length; i++) {
              if (/^[0-9]+$/.test(value.charAt(i))) {
                bandera++;
                if (bandera == 2) {
                  return true;
                }
              }
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Caracteres de simbolos: minimo 1 caracter especial",
          isValid: (value) => {
            for (let i = 0; i < value.length; i++) {
              if (!/[a-zA-Z0-9]/.test(value.charAt(i))) {
                return true;
              }
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Letras mayúsculas: minimo 1 letra mayúscula",
          isValid: (value) => {
            for (let i = 0; i < value.length; i++) {
              if (/[A-Z]/.test(value.charAt(i))) {
                return true;
              }
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Letras minúsculas: minimo 1 letra minúscula",
          isValid: (value) => {
            for (let i = 0; i < value.length; i++) {
              if (/[a-z]/.test(value.charAt(i))) {
                return true;
              }
            }
            return false;
          },
          class: "text-danger",
        },
      ],
    };
  },
  components: {
    tareas: Tareas_View,
    rankingview: Ranking_View,
    modalidadxmes: ModalidadxMes,
    misconstancias: MisConstancias,
    miscursosinstructor: MisCursosInstructor,
    capacitacionxregion: CapacitacionxRegion,
    encuestas: Encuestas,
    administradorview: AdministradorView,
    participanteview: ParticipanteView,
    noticiasview: NoticiasView,
    climaview: ClimaView,
    nuevasTabs,
    SlidesBienvenida,
    ProveedorView
  },
  methods: {
    validar() {
      this.reglas.forEach((element) => {
        if (element.isValid(this.nuevaCont)) {
          element.class = "text-success";
          return element;
        } else {
          element.class = "text-danger";
          return element;
        }
      });
      let rest = this.reglas.filter((element) => {
        return !element.isValid(this.nuevaCont);
      });
      return rest;
    },
    setModuloActual(evt) {
      this.moduloSlidesActual = evt;
    },
    consultarSlides() {
      let that = this;
      if (this.menu.usuario.perfil_sistema) {
        this.slides = [];
        this.$http
          .get("lms/slides/" + this.menu.usuario.perfil_sistema)
          .then((respuesta) => {
            return respuesta.json();
          })
          .then((respuestaJson) => {
            that.slides = respuestaJson.slides;
            if (this.slides.length > 0) {
              this.moduloSlidesActual = this.slides[0].tipo;
              $("#modalSlides").modal("show");
            }
          })
          .catch(function (error) {
            toastr.error(
              "Hubo un problema consultando los anuncios de bienvenida, ponte en contacto con tu proveedor de servicio"
            );
            that.Listo();
          });
      }
    },

    noVerSlides() {
      this.$http
        .post("lms/slides/noMostrarSlides", {
          perfil_sistema: this.menu.usuario.perfil_sistema,
          slides: this.slides_cve,
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.res == "Excelente") {
            toastr.info("Estos avisos y noticias no se mostrarán de nuevo");
          } else {
            toastr.error(
              "Hubo un problema con los anuncios de bienvenida, ponte en contacto con tu proveedor de servicio"
            );
          }
        })
        .catch(function (error) {
          toastr.error(
            "Hubo un problema con los anuncios de bienvenida, ponte en contacto con tu proveedor de servicio"
          );
          that.Listo();
        });
    },
    cambiarContrasena() {
      let that = this;
      if (this.repCont === this.nuevaCont) {
        this.$http
          .post("usuarios/cambiarContrasena", {
            pass: this.contAct,
            newPass: this.nuevaCont,
          })
          .then((respuesta) => {
            return respuesta.json();
          })
          .then((respuestaJson) => {
            if (respuestaJson.resp == "Excelente") {
              swal(respuestaJson.resp, "Usuario actualizado", "success");
              setTimeout(() => {
                $("#modalChangePass").modal("hide");
                that.$http
                  .delete(
                    "../pri/usuarios/sesiones/eliminar/" +
                      that.menu.usuario.cve_empleado +
                      "/web"
                  )
                  .then((respuesta) => {
                    return respuesta.json();
                  })
                  .then((respuestaJson) => {
                    this.Actualizar_Token(this.menu.tokenGenerico);
                    this.$router.push({ name: "Login" });
                    location.reload(true);
                  });
              }, 1500);
            } else {
              that.Listo();
              swal("!Ups¡", respuestaJson.resp, "error");
            }
          })
          .catch(function (error) {
            console.log("Error en Cambiar_Contrasena", error);
            that.Listo();
          });
      } else {
        swal(
          "Error de datos",
          "Favor de revisar que las contraseñas coincidan",
          "error"
        );

        that.Listo();
      }
    },
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    Listo() {
      this.loading = "d-none";
      this.result = "";
    },
    Definir_Buttons_Config() {
      var that = this;
      this.menu.buttons.excel = false;
      this.menu.buttons.consultar = false;
      this.menu.buttons.consultar_name = "Actualizar";
      this.menu.buttons.imprimir = false;
      this.menu.buttons.nuevo = false;
      this.menu.buttons.nuevo_name = "Nuevo";
      this.menu.filtros.fechas.mostrar = false;
      $("#Consultar_Button").unbind();
      this.menu.excel.headers = {};
      this.menu.excel.data = [];
      this.menu.excel.fileName = "";
    },
    ...mapActions(["Actualizar_Help_Button", "Actualizar_Token"]),
  },
  computed: {
    menu() {
      return this.$store.getters.getMenu;
    },
    slides_cve() {
      let arr = [];
      this.slides.map((elm) => {
        arr.push({ cve_slide: elm.cve_slide });
      });
      return arr;
    },
    cia() {
      return this.$store.getters.getCia;
    },
    usuario() {
      return this.$store.getters.getUsuario;
    },
    usuario_permisos() {
      return this.$store.getters.getUsuario_Permisos;
    },
    permitirEnvio() {
      if (
        this.classPass == "is-valid" &&
        this.classPass1 == "is-valid" &&
        this.contAct != ""
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    nuevaCont: function () {
      let rest = this.validar();
      if (rest.length > 0) {
        this.classPass = "is-invalid";
      }
      if (rest.length == 0) {
        this.classPass = "is-valid";
      }
    },
    repCont() {
      if (this.nuevaCont == this.repCont) {
        this.classPass1 = "is-valid";
      } else {
        this.classPass1 = "is-invalid";
      }
    },
    "menu.usuario": {
      deep: true,
      handler(usuario) {
        this.consultarSlides();
      },
    },
  },
  created() {
    var that = this;
    this.menu.opcion.name = "Dashboard";
    this.menu.opcion.mostrar_name = false;
    this.menu.opcion.origin1.name = "";
    this.menu.opcion.origin1.route = "";
    this.menu.opcion.origin2.name = "";
    this.menu.opcion.origin2.route = "";
    this.menu.opcion.origin3.name = "";
    this.menu.opcion.origin3.route = "";
    this.Listo();
  },
  mounted() {
    var that = this;
    this.Definir_Buttons_Config();
    this.Actualizar_Help_Button({
      mostrar: true,
      title: "Dashboard",
      content: "Dashboard",
    });
    var meses = new Array(
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    );
    var diasSemana = new Array(
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    );
    var f = new Date();
    this.fecha_actual =
      diasSemana[f.getDay()] +
      ", " +
      f.getDate() +
      " de " +
      meses[f.getMonth()] +
      " de " +
      f.getFullYear();
    this.consultarSlides();
    $("#modalSlides").on("hidden.bs.modal", function (e) {
      if (that.statusSlidesBienvenida) {
        that.noVerSlides();
        that.statusSlidesBienvenida = false;
      }
    });
  },
};
</script>

<style scoped>
#nombreEmpleado {
  text-transform: none !important;
}

#modalSlides .modal-dialog > .modal-content {
  max-height: 75vh;
}
.text-end{
  text-align: end;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Dashboard.vue